import useSWR, { useSWRConfig } from 'swr';

const useExternalLoginProviders = (dataClient, swrOptions = {}) => {
    const url = '/identity/externalAccount/providers';
    const swrConfig = useSWRConfig();

    dataClient.swrConfig = swrConfig;

    if (swrOptions.refreshInterval > 0) {
        dataClient.cacheExirationMs = swrOptions.refreshInterval;
    }

    const { data, error, isValidating, mutate } = useSWR(url, dataClient.fetcher);

    const result = {
        result: data ? data : null,
        isLoading: !error && !data,
        isError: !(!error),
        error: error,
        isValidating: isValidating,
        refetchResult: mutate,
    }

    return result;
}

export {
    useExternalLoginProviders
}